/**
 * Columns per row in the character and emoji grids.
 *
 * The keyboard model (arrow keys, Home, End) reads this, not a CSS value. The
 * stylesheet's `repeat(8, 2rem)` has to stay in lockstep -- that is why the
 * colour picker exports `PALETTE_COLUMNS` rather than counting cells at runtime.
 */
export const GLYPH_COLUMNS = 8

/** Common typographic characters, named for the grid's accessible labels. */
export const CHARACTERS: ReadonlyArray<{ char: string; name: string }> = [
  { char: '©', name: 'Copyright' },
  { char: '®', name: 'Registered' },
  { char: '™', name: 'Trademark' },
  { char: '§', name: 'Section' },
  { char: '¶', name: 'Pilcrow' },
  { char: '†', name: 'Dagger' },
  { char: '‡', name: 'Double dagger' },
  { char: '•', name: 'Bullet' },
  { char: '…', name: 'Ellipsis' },
  { char: '–', name: 'En dash' },
  { char: '—', name: 'Em dash' },
  { char: '‘', name: 'Left single quote' },
  { char: '’', name: 'Right single quote' },
  { char: '“', name: 'Left double quote' },
  { char: '”', name: 'Right double quote' },
  { char: '«', name: 'Left guillemet' },
  { char: '»', name: 'Right guillemet' },
  { char: '€', name: 'Euro' },
  { char: '£', name: 'Pound' },
  { char: '¥', name: 'Yen' },
  { char: '¢', name: 'Cent' },
  { char: '°', name: 'Degree' },
  { char: '±', name: 'Plus minus' },
  { char: '×', name: 'Multiply' },
  { char: '÷', name: 'Divide' },
  { char: '≠', name: 'Not equal' },
  { char: '≈', name: 'Almost equal' },
  { char: '≤', name: 'Less or equal' },
  { char: '≥', name: 'Greater or equal' },
  { char: 'µ', name: 'Micro' },
  { char: '∞', name: 'Infinity' },
  { char: '←', name: 'Left arrow' },
  { char: '→', name: 'Right arrow' },
  { char: '↑', name: 'Up arrow' },
  { char: '↓', name: 'Down arrow' },
  { char: '½', name: 'One half' },
  { char: '¼', name: 'One quarter' },
  { char: '¾', name: 'Three quarters' },
  { char: 'á', name: 'a acute' },
  { char: 'é', name: 'e acute' },
]

export const EMOJI: ReadonlyArray<{ char: string; name: string }> = [
  { char: '😀', name: 'Grinning' },
  { char: '😃', name: 'Smiling' },
  { char: '😄', name: 'Smile' },
  { char: '😁', name: 'Beaming' },
  { char: '😅', name: 'Sweat smile' },
  { char: '😂', name: 'Tears of joy' },
  { char: '😉', name: 'Winking' },
  { char: '😊', name: 'Blush' },
  { char: '😍', name: 'Heart eyes' },
  { char: '😘', name: 'Kiss' },
  { char: '😎', name: 'Sunglasses' },
  { char: '😢', name: 'Crying' },
  { char: '😭', name: 'Loudly crying' },
  { char: '😡', name: 'Angry' },
  { char: '👍', name: 'Thumbs up' },
  { char: '👎', name: 'Thumbs down' },
  { char: '👏', name: 'Clapping' },
  { char: '🙏', name: 'Folded hands' },
  { char: '💪', name: 'Flexed biceps' },
  { char: '🔥', name: 'Fire' },
  { char: '✨', name: 'Sparkles' },
  { char: '⭐', name: 'Star' },
  { char: '❤️', name: 'Red heart' },
  { char: '💔', name: 'Broken heart' },
  { char: '✅', name: 'Check mark' },
  { char: '❌', name: 'Cross mark' },
  { char: '⚠️', name: 'Warning' },
  { char: '🎉', name: 'Party' },
  { char: '📌', name: 'Pin' },
  { char: '💡', name: 'Light bulb' },
  { char: '📝', name: 'Memo' },
  { char: '🔗', name: 'Link' },
]
